import { useStore } from '@nanostores/react'
import { $isLoggedIn } from '@/stores/account/computed'
import { CustomerSubscriptions } from './CustomerSubscriptions/CustomerSubscriptions'
import { CustomerWelcome } from './CustomerWelcome/CustomerWelcome'
import { RecentPurchases } from './RecentPurchases/RecentPurchases'
import './LoggedInHero.scss'
import { Packages } from '../Account/Packages/Packages'
import type React from 'react'

export const LoggedInHero: React.FC = () => {
  const isLoggedIn = useStore($isLoggedIn)

  if (!isLoggedIn) return null

  return (
    <div className="c-logged-in-hero">
      <div className="c-logged-in-hero__wrapper">
        <div className="c-logged-in-hero__header">
          <CustomerWelcome />
        </div>
        <div className="c-logged-in-hero__content">
          <CustomerSubscriptions />
          <Packages homePage={true} />
          <RecentPurchases />
        </div>
      </div>
    </div>
  )
}
